export const IDLE_TIMEOUT = 30 * 60 * 1000;

export const IDLE_LAST_ACTIVE_KEY = "last_activity";

export const IDLE_EVENTS = [
  "mousemove",
  "keydown",
  "wheel",
  "DOMMouseScroll",
  "mousewheel",
  "mousedown",
  "touchstart",
  "touchmove",
  "MSPointerDown",
  "MSPointerMove",
  "visibilitychange",
  "focus",
];
